import { render } from "./memory.vue?vue&type=template&id=148a7884&scoped=true"
import script from "./memory.vue?vue&type=script&lang=js"
export * from "./memory.vue?vue&type=script&lang=js"

import "./memory.vue?vue&type=style&index=0&id=148a7884&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148a7884"]])

export default __exports__